import React from 'react';
import {
  DropdownDivider,
  DropdownItem,
  DropdownItemGroup,
  DropdownItemStatic,
  DropdownItemWithActionConfirmation,
  SubDropdown,
  SubDropdownWithSearch,
} from '../subcomponents';
import {
  DropdownItem as DropdownItemType,
  DropdownComponentProps,
} from '../subcomponents/types';

type KeepItemPredicate = (_: DropdownItemType) => boolean;

export const resolveItemComponent = (
  item: DropdownItemType,
): React.FC<DropdownComponentProps> => {
  let DropdownComponent: React.FC<DropdownComponentProps>;

  if (item.isDivider()) {
    DropdownComponent = DropdownDivider;
  } else if (item.isGroup()) {
    DropdownComponent = DropdownItemGroup;
  } else if (item.hasSearch()) {
    DropdownComponent = SubDropdownWithSearch;
  } else if (item.hasChildren()) {
    DropdownComponent = SubDropdown;
  } else if (item.isNote()) {
    DropdownComponent = DropdownItemStatic;
  } else if (item.requiresConfirmation()) {
    DropdownComponent = DropdownItemWithActionConfirmation;
  } else {
    DropdownComponent = DropdownItem;
  }

  return DropdownComponent;
};

export const getItemsIntoComponentsTransformer =
  (parentLevel: string, keepItemPredicate: KeepItemPredicate = () => true) =>
  (items: DropdownItemType[]) =>
    items.reduce((components, item, itemIndex) => {
      if (!(item && keepItemPredicate(item))) {
        return components;
      }

      const DropdownComponent = resolveItemComponent(item);

      const itemLevel = `${parentLevel}.${itemIndex}`;

      return [
        ...components,
        <DropdownComponent key={itemLevel} itemLevel={itemLevel} item={item} />,
      ];
    }, [] as JSX.Element[]);
